import React, { useState } from "react";
import PopUp from "../containers/PopUp";
import AddressShipping from "../../components/addressShipping/AddressShipping";
import {
  resendVerificationEmail,
  sendVerifiedMail,
} from "../../server/Customer";
import { useDispatch } from "react-redux";
import * as actionType from "../../store/action";

const UserResetEmail = ({ emailPassword, Email, Password, customerId }) => {
  const [verificationCode, setVerificationCode] = useState("");
  const [addAddress, setAddAddress] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    check();
  };

  const check = () => {
    dispatch(sendVerifiedMail(verificationCode))
      .then(() => {
        setAddAddress(true);
      })
      .catch((err) => {
        console.error("Verification error:", err);
      });
  };

  const resendEmail = () => {
    dispatch(resendVerificationEmail()).catch((err) => {
      console.error("Resend verification error:", err);
    });
  };

  return (
    <PopUp
      width="700px"
      close={() => dispatch({ type: actionType.VERIFIED_EMAIL })}
    >
      {addAddress ? (
        <AddressShipping
          parent="reset"
          setSelectedAddres={() =>
            dispatch({ type: actionType.VERIFIED_EMAIL })
          }
        />
      ) : (
        <div className="register-mail">
          <div className="register-head">
            <h3> ההרשמה כמעט הושלמה, עכשיו רק נשאר לאמת את המייל</h3>
          </div>
          <div className="register-body">
            <p>יש להכניס את הסיסמה שקיבלתם למייל</p>
            <form onSubmit={handleSubmit}>
              <div>
                <input
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                />
              </div>
              <div>
                <button className="btn" type="submit">
                  לאישור
                </button>
                <button
                  className="forgot-pass resend-email-btn"
                  type="button"
                  onClick={resendEmail}
                >
                  שליחת קוד חדש
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </PopUp>
  );
};

export default UserResetEmail;
